<template>
  <div class="d-flex flex-row inherit-height">
    <div
      class="d-flex flex-row flex-wrap inherit-height"
      :style="mdAndDown ? 'width:100%;overflow-x:scroll' : ''"
      style="flex: 1; overflow-y: scroll; overflow-x: hidden"
    >
      <div class="d-flex flex-column full-width inherit-height" :style="mdAndDown ? 'width:900px' : ''">
        <div class="d-flex flex-row op-header" style="padding-bottom: 2px">
          <div
            v-for="day in ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']"
            :key="day"
            class="d-flex full-width justify-center text-center weekday-header"
            style="width: calc(100% / 7); overflow: hidden; text-overflow: ellipsis"
          >
            {{ $t(day) }}
          </div>
        </div>

        <div class="d-flex flex-row flex-wrap flex-grow-1" style="align-content: flex-start; overflow-y: scroll" :style="mdAndDown ? 'width:900px' : ''">
          <div
            class="d-flex flex-column"
            style="max-width: calc(100% / 7); min-width: 80px !important; width: calc(100% / 7)"
            v-for="dutyCalItem in dutiesCalendarByDayNum"
            :key="dutyCalItem.d"
            :id="getDateForId(dutyCalItem.date)"
          >
            <div
              class="d-flex flex-column pa-2 ma-1"
              :class="boxClass(dutyCalItem)"
              :style="boxStyle(dutyCalItem)"
              style="height: 160px"
              @click="onDutySelected(dutyCalItem.duty)"
            >
              <!-- {date,d,dateStr,duty:dutiesByDay[dateStr]} -->
              <div class="justify-center text-center font-weight-bold">
                {{ getDateFromDutiesCalendarItem(dutyCalItem.d) }}
              </div>
              <div v-if="dutyCalItem.duty" class="justify-center full-width">
                <div class="justify-center align-center text-center text-h6">
                  <v-chip v-if="xl" outlined class="op-text">{{ $t('myDuty.title') }} {{ dutyCalItem.duty.dutyname }}</v-chip>
                  <div v-else class="op-text">{{ dutyCalItem.duty.dutyname }}</div>
                </div>
                <duty-from-to
                  :duty-activities="getDutyActivities(dutyCalItem.duty)"
                  :tenant="tenant"
                  :showDutyCalendarLocation="!hideDutyCalendarLocation"
                ></duty-from-to>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedDuty" class="d-flex flex-column inherit-height" style="width: 512px">
      <duty-activities-and-documents :duty="selectedDuty" :duty-activities="getDutyActivities(selectedDuty)">
        <template #header2Right
          ><v-btn v-if="!hideDutyView" outlined rounded @click="$router.push(`/myduties/detail/${selectedDuty.id}`)"
            >{{ $t('dutyView') }}<v-icon right>mdi-arrow-right</v-icon></v-btn
          ></template
        >
      </duty-activities-and-documents>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import dateUtils from '@/common/dateUtils';
import DutyFromTo from '@/modules/myDuties/components/DutyFromTo.vue';
import dutyMixin from '@/modules/myDuties/common/dutyMixin';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import dutyActivities from '@/modules/myDuties/dutyActivities/DutyActivities.vue';
import index from '../index';
import commonMixin from '@/mixins/common';
import DutyActivitiesAndDocuments from '@/modules/myDuties/components/DutyActivitiesAndDocuments.vue';
import { HOURS_IN_MS } from '@/common/constants';

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
export default {
  name: 'DutiesCalendar',
  components: { DutyActivitiesAndDocuments, DutyFromTo }, //FahrdienstDocsByDocType
  mixins: [commonMixin, dutyMixin, dateTimeMixin],
  data() {
    return {
      mergeAllDuties: true,
      tab: 'dutyActivities',
    };
  },
  mounted() {
    console.debug(`DutiesCalendar mounted ${this.$route.params.dutyId}`);
    if (this.duties && !this.$route.params.dutyId) {
      this.selectToday();
    }
  },
  computed: {
    ...mapState({ tenant: (state) => state.profile.customerRelations.tenant }),
    ...mapState('meinDienst', ['duties', 'dutiesById']),
    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    hideDutyView() {
      return !!this.moduleConfig.hideDutyView;
    },
    hideDutyCalendarLocation() {
      return !!this.moduleConfig.hideDutyCalendarLocation;
    },
    selectedDuty() {
      return this.dutiesById[this.$route.params.dutyId];
    },
    dutiesCalendarByDayNum() {
      let sortedDuties = this.duties.slice().sort((d1, d2) => {
        let date1 = dateUtils.parseISOString(d1.day);
        let date2 = dateUtils.parseISOString(d2.day);
        return date1.getTime() - date2.getTime();
      });
      if (sortedDuties.length === 0) {
        sortedDuties.push({ day: new Date().toISOString() });
      }
      let firstDate = dateUtils.parseISOString(sortedDuties[0].day);
      // On monday the monday was displayed on Tuesday. First intention was to correct the time by the timezone offset
      // However, this turned out to be wrong. The issue was because of the offset=7 for Sundays which is wrong, because the offset is zero-based.

      // console.debug("firstDate before correction",sortedDuties[0].day,firstDate,"first Date day",firstDate.getDay())
      // console.debug("firstDate timeZone offset", firstDate.getTimezoneOffset() ) // -60 wintertime
      // firstDate.setTime(firstDate.getTime()-firstDate.getTimezoneOffset()/60 *HOURS_IN_MS);
      // console.debug("firstDate after correction",firstDate,"first Date day",firstDate.getDay())
      let offset;
      let day = firstDate.getDay();
      if (day >= 1) {
        offset = day - 1;
      } else {
        offset = 6;
      }

      let firstMonday = new Date(firstDate.getTime() - offset * ONE_DAY_IN_MS);
      console.debug('firstMonday', firstMonday);
      function createKey(date) {
        return `${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}`;
      }
      let dutiesByDay = {};
      sortedDuties.forEach((d) => {
        let date = dateUtils.parseISOString(d.day);
        dutiesByDay[createKey(date)] = d;
      });

      let daysCount = (dateUtils.parseISOString(sortedDuties[sortedDuties.length - 1].day).getTime() - firstDate.getTime()) / ONE_DAY_IN_MS + offset;
      let calendarDaysDisplayed = this.moduleConfig.calendarDaysDisplayed || 35;
      daysCount += 1; // 1 is added to show duty which sits at the edge of total counted days but gets ignored due to timezone
      daysCount = Math.max(calendarDaysDisplayed, daysCount);
      let dutiesCalendarByTime = [];

      let timeFirstMonday = firstMonday.getTime();
      for (let d = 0; d < daysCount; d++) {
        let date = new Date(timeFirstMonday + d * ONE_DAY_IN_MS);
        let dateStr = createKey(date);
        dutiesCalendarByTime.push({ date, d, weekday: date.getDay(), dateStr, duty: dutiesByDay[dateStr] });
      }
      return dutiesCalendarByTime;
    },
  },
  methods: {
    isToday(date) {
      const today = new Date();
      return date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate();
    },
    boxClass(dutyCalItem) {
      let classes = 'day-box ';
      if (dutyCalItem.duty && this.selectedDuty) {
        classes += `${dutyCalItem.duty && dutyCalItem.duty.id === this.selectedDuty.id ? 'selected-day' : ''}`;
      }
      if (this.isToday(dutyCalItem.date)) classes += ' current-day';
      return classes;
    },
    boxStyle(dutyCalItem) {
      if (this.themeName === 'light') {
        if (dutyCalItem.weekday === 6) return `background:${this.moduleConfig.colorWeekday6}`;
        if (dutyCalItem.weekday === 0) return `background:${this.moduleConfig.colorWeekday7}`;
      } else {
        if (dutyCalItem.weekday === 0) return `background:#404040`;
        if (dutyCalItem.weekday === 6) return `background:#464646`;
      }

      return;
    },
    getDateFromDutiesCalendarItem(dayNumber) {
      let dateDuty = this.dutiesCalendarByDayNum[dayNumber];
      return this.lgAndUp ? dateUtils.formatAsLocaleShortDate(dateDuty.date) : dateUtils.formatAsLocaleDayMonth(dateDuty.date);
    },
    getDateForId(date) {
      let dateDuty = '';
      try {
        dateDuty = date.toISOString().split('T')[0];
      } catch (err) {
        // fail silently
      }
      return dateDuty;
    },
    getDateToday() {
      return new Date().toISOString().split('T')[0];
    },
    getDutyActivities(duty) {
      return this.mx_getDutyActivities(duty, { tenant: this.tenant });
    },
    onDutySelected(duty) {
      if (duty && Number(this.$route.params.dutyId) !== duty.id) {
        this.$router.push(`/myduties/${duty.id}?noTransition`);
      }
    },
    displayDutyActivityTracks() {},
    displayDutyActivityTracksOfOneTrack() {},

    selectToday() {
      let today = new Date().toISOString();
      let todaysDuty = this.duties.find((duty) => dateUtils.isSameDateIsoString(duty.day, today));
      if (todaysDuty) {
        if (Number(this.$route.params.dutyId) !== todaysDuty.id) {
          this.$router.push(`/myduties/${todaysDuty.id}?noTransition`);
          this.scrollToDay(today);
        }
      }
    },
    scrollToDay(today) {
      window.setTimeout(() => {
        location.href = '#' + today.split('T')[0];
      }, 1200);
    },
  },
  watch: {
    duties(newValue, oldValue) {
      this.selectToday();
    },
  },
};
</script>
<style scoped>
.current-day {
  font-weight: bolder;
}
.theme--light .current-day {
  background: #adada5 !important;
  color: white;
}
.theme--dark .current-day {
  background: #404040 !important;
  color: white;
}

.day-box,
.weekend-box {
  border-radius: 8px;
}
.theme--light .day-box {
  background: #f0f0f0;
}
.theme--dark .day-box {
  background: #272727;
}
.theme--light .weekend-box {
  background: #d0d0d0;
}
.theme--dark .weekend-box {
  background: #202020;
}
.theme--light .selected-day {
  border: 2px solid black;
}
.theme--dark .selected-day {
  border: 2px solid #a0a0a0;
}
.weekday-header {
  font-size: 0.875rem !important;
  padding: 3px 0 4px 0;
}
</style>
